module.exports = __webpack_public_path__ + "static/media/gd.790e1345.svg";